import {ValueObject} from '@s-ui/domain'

export class BreadcrumbSeoValueObject extends ValueObject {
  #label
  #params
  #url

  constructor({label, params, url}) {
    super()
    this.#label = label
    this.#params = params
    this.#url = url
  }

  static create({label, params, url}) {
    return new BreadcrumbSeoValueObject({label, params, url})
  }

  get label() {
    return this.#label
  }

  get params() {
    return this.#params
  }

  get url() {
    return this.#url
  }

  get value() {
    return {
      label: this.#label,
      params: this.#params,
      url: this.#url
    }
  }

  toJSON() {
    return {
      label: this.#label,
      params: this.#params,
      url: this.#url
    }
  }
}
